export enum SiteSettingType {
  EnableMyZoneEquipment = 'myzone_equipment',
  EnableTrainingAccess  = 'employee_training',
  ExludeNoAccessUsers   = 'exclude_no_access',
  EmailOnNotify         = 'email_notification',
  EmployeeCanEdit       = 'employee_profile_edit',
}
